$
<template>
  <section class="section -mid-top -marg cta-contact">
    <h2 class="section__title">{{ title }}</h2>
    <RawHtml class="section__legend" :html="subtitle" />

    <div class="cta-contact__actions">
      <RouterLink class="button -link" :to="openPanelLink">Nous contacter</RouterLink>
      <RouterLink
        v-if="linkLabel"
        :to="to ? to : { name: routeName }"
        class="section__link cta-contact__link"
      >
        {{ linkLabel }}
        <Icon id="leaves" />
      </RouterLink>
    </div>
  </section>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import RawHtml from '@/components/global/RawHtml.vue'

export default {
  name: 'CtaContactSection',
  components: { RawHtml, Icon },
  props: {
    title: { type: String, default: null },
    subtitle: { type: String, default: null },
    linkLabel: { type: String, default: null },
    to: { type: String, default: null },
    routeName: { type: String, default: 'support' },
  },
  computed: {
    openPanelLink() {
      return {
        name: this.$route.name,
        query: {
          ...this.$route.query,
          contact: true,
        },
      }
    },
  },
}
</script>
